module.exports = __webpack_public_path__ + "static/media/upload_csv_icon.dea7609f.png";